// -----------------------------------------------
// VC Projects JS
// -----------------------------------------------

// Alpine.js support (if using)
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import sort from '@alpinejs/sort'
import trixEvents from './trix'
import MasonIt from "mason-it";
import htmxEvents from './htmx';
import nativeLazy from './native-lazy';
import alpineHelpers from './alpineHelpers';
import feather from 'feather-icons';

window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.plugin(sort)
Alpine.start()
window.alpineHelpers = alpineHelpers;
window.trixEvents = trixEvents;

var elementsToReplace = document.querySelectorAll('[data-feather]');

Array.from(elementsToReplace).forEach(function (element) {
  let icon = element.getAttribute('data-feather');
  if (typeof feather.icons[icon] === 'undefined') {
    element.removeAttribute('data-feather');
  }
});
feather.replace();

// Frontend validation, tooltips, tracking, etc.
document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('form[data-validate]');
  forms.forEach(form => {
    form.addEventListener('submit', e => {
      // Simple example: require checkboxes with [required]
      const requiredChecks = form.querySelectorAll('input[type="checkbox"][required]');
      for (let checkbox of requiredChecks) {
        if (!checkbox.checked) {
          e.preventDefault();
          alert('Please check all required boxes.');
          checkbox.focus();
          return;
        }
      }
    });
  });
  trixEvents.init();

  MasonIt.init("data-masonry");

  nativeLazy();
  
  // Load more functionality
  const $loadMore = document.querySelector('[data-masonry-load-more]');
  if ($loadMore) {
    $loadMore.addEventListener('click', handleLoadMore);
  }

  function handleLoadMore(e) {
    e.preventDefault();
    const button = e.target;
    const projectId = button.dataset.projectId;
    const currentPage = parseInt(button.dataset.currentPage);
    const perPage = parseInt(button.dataset.perPage);
    const nextPage = currentPage + 1;
    
    // Disable button during loading
    button.disabled = true;
    button.textContent = 'Loading...';
    
    // Make AJAX request
    fetch(`/actions/video-consortium-module/projects/project-images?project-id=${projectId}&page=${nextPage}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      if (data.stills && data.stills.length > 0) {
        addImagesToMasonry(data.stills);
        button.dataset.currentPage = nextPage;
        
        // Hide button if no more pages
        if (!data.hasNextPage) {
          button.style.display = 'none';
        }
      } else {
        button.style.display = 'none';
      }
    })
    .catch(error => {
      console.error('Error loading more images:', error);
      button.textContent = 'Error loading images';
    })
    .finally(() => {
      button.disabled = false;
      if (button.textContent === 'Loading...') {
        button.textContent = 'Load more';
      }
    });
  }

  function addImagesToMasonry(images) {
    const $masonry = document.querySelector('[data-masonry]');
    const $template = document.querySelector('[data-masonry-template]');
    
    if (!$masonry || !$template) return;
    
    images.forEach(image => {
      const $clone = $template.content.cloneNode(true);
      const $li = $clone.querySelector('li');
      const $img = $clone.querySelector('img');
      
      // Set the aspect ratio
      $li.style.aspectRatio = `${image.aspectRatio}`;
      
      // Set image attributes
      $img.src = image.url;
      $img.alt = image.altText || image.title || '';
      
      // Append to masonry container
      $masonry.appendChild($clone);
    });
    
    // Reinitialize masonry if needed
    if (window.MasonIt) {
      MasonIt.refresh();
    }
  }

  htmxEvents.init();
});
